'use strict';

angular.module('shiftTraderApp')
    .controller('OrganizationMessageShowCtrl', function ($scope, $location, flash, Users, OrganizationMessages, $timeout,
                                                         allPositions, me, org, orgMessage, UserPermissionsService) {
      $scope.me = me;
      $scope.org = org;
      $scope.departments = $scope.org.departments;

      $scope.positions = _.map(allPositions, function(pos) {
        if (_.isNull(pos.department_id)) {
          pos.department = {
            name: 'Uncategorized'
          };
        } else {
          var dept = _.find($scope.departments, {id: pos.department_id});
          if (!_.isUndefined(dept)) {
            pos.department = dept;
          }
        }

        return pos;
      });

      $scope.state = {
        rawPermissions: null
      };

      var permissionsToLookUp = [
        'organization_messages.view_results'
      ];

      function processRawPermissions() {
        $scope.state.derivedPermissions = {
          canViewResults: $scope.state.rawPermissions['organization_messages.view_results']
        };
      }

      UserPermissionsService.getCanDict(permissionsToLookUp, $scope.org.id)
        .then(function(dikt) {
          $scope.state.rawPermissions = dikt;

          processRawPermissions();
        });

      $scope.orgMessage = orgMessage;

      _.each($scope.orgMessage.organization_message_responses, function(omr) {
        omr._sort = {
          first_name: omr.user.first_name,
          last_name: omr.user.last_name,
          acknowledged_at: omr._acknowledged_at_unix,
          sent_at: moment(omr.created_at).unix()
        };
      });

      $scope.orgMessage.organization_message_responses = _.sortBy($scope.orgMessage.organization_message_responses, function(omr) {
        return omr._acknowledged_at_unix + ' ' + omr.user.first_name;
      });

      $scope.sortField = '_sort.acknowledged_at';
      $scope.sortDir = '+';
      $scope.changeSort = function(fieldName) {
        if (fieldName === $scope.sortField) {
          if ($scope.sortDir === '+') {
            $scope.sortDir = '-';
          } else {
            $scope.sortDir = '+';
          }
        } else {
          $scope.sortField = fieldName;
          $scope.sortDir = '+';
        }
      };

      $scope.chartTicks = (function() {
        var lengthOfCreatedToExpiredInHours = moment($scope.orgMessage.created_at).twix($scope.orgMessage.expires_at).length('hours');
        var intervalLengthInHours = 1;
        var numIntervals = Math.floor(lengthOfCreatedToExpiredInHours / intervalLengthInHours);

        while (numIntervals > 10) {
          intervalLengthInHours += 1;
          numIntervals = Math.floor(lengthOfCreatedToExpiredInHours / intervalLengthInHours);
        }

        console.log(lengthOfCreatedToExpiredInHours, intervalLengthInHours, numIntervals);

        if (numIntervals * intervalLengthInHours > lengthOfCreatedToExpiredInHours) {
          numIntervals -= 1; // remove one interval so that expires_at will be last endpoint instead of a point PAST expires_at
        }

        var points = [moment($scope.orgMessage.created_at).minutes(0).seconds(0).milliseconds(0).unix()];
        points.push.apply(points, _.map(_.range(numIntervals), function(x) {
          return moment($scope.orgMessage.created_at).minutes(0).seconds(0).milliseconds(0).add(intervalLengthInHours * (x + 1), 'hours').unix();
        }));
        points.push(moment($scope.orgMessage.expires_at).unix());
        return points;
      })();

      $scope.dataInInterval = (function() {
        return _.map(_.range($scope.chartTicks.length - 1), function(idx) {
          return _.where($scope.orgMessage.organization_message_responses, function(omr) {
            return !_.isNull(omr.acknowledged_at) && (omr._acknowledged_at_unix >= $scope.chartTicks[idx]) && (omr._acknowledged_at_unix < $scope.chartTicks[idx + 1]);
          }).length;
        });
      })();

      $scope.sortedAcknowledgedResponses = _.sortBy(_.where($scope.orgMessage.organization_message_responses, function(omr) {
        return !_.isNull(omr.acknowledged_at);
      }), '_acknowledged_at_unix');

      $scope.orgMessageResponsesChartData = [
        {
          key: 'Message Responses',
          area: true,
          values: (function() {
            return _.map($scope.sortedAcknowledgedResponses, function(omr, idx) {
              return [omr._acknowledged_at_unix, idx + 1];
            });
          })()
        }
      ];

      $scope.xAxisTickValuesFunction = function(){
        return function(){

          return $scope.chartTicks;
        };
      };

      $scope.xAxisTickFormatFunction = function(){
        return function(d){
          return d3.time.format('%b %-d, %-I%p')(new Date(d * 1000)).slice(0,-1);
        }
      };

      $scope.toolTipContentFunction = function(){
        return function(key, x, y, e, graph) {
          var resp = $scope.sortedAcknowledgedResponses[e.pointIndex];
          return  '<p style="text-align: center;"><b>' + y + ' Responses</b></p>' +
              '<p>' + resp.user.name + '<br/> @ ' + resp.acknowledged_at.format('h:mma').slice(0,-1) + '</p>';
        };
      };

      $scope.forces = {
        x: [moment($scope.orgMessage.expires_at).unix()],
        y: [0, $scope.orgMessage._numActiveRecipients]
      };

      $scope.colorFunction = function() {
        return function(d, i) {
          return '#00b3b5';
        };
      };

      $scope.goToProfile = function(emp_id) {
        $location.path('profile/' + emp_id);
      };

      $scope.myResponse = _.find($scope.orgMessage.organization_message_responses, {user_id: $scope.me.id});

      $scope.acknowledgeMessage = function (messageResp) {
        messageResp.$sendAcknowledgement()
            .then(function (response) {
              $scope.acknowledgementSent = true;
              $scope.orgMessage.$calculateAcknowledgmentStats();

            }, function (response) {
              console.log('error in response when sending acknowledgement');
            });
      };

    if ($scope.myResponse) {
      $timeout(function() {
        $('.organization_message_embedded_link').on('mousedown', function(e) {
          $scope.myResponse.$trackLink(e.target.href);
        });
      }, 300);
    }

    _.each($scope.orgMessage.organization_message_responses, function(resp) {
      resp._clickData = resp.$clickedLinks($scope.orgMessage);
      resp._cssClasses = {
        first_link: _.findIndex(resp._clickData, {messageLinkNumber: 1}) > -1,
        second_link: _.findIndex(resp._clickData, {messageLinkNumber: 2}) > -1,
        third_link: _.findIndex(resp._clickData, {messageLinkNumber: 3}) > -1,
        acknowledged: resp.$isAcknowledged(),
        not_acknowledged: !resp.$isAcknowledged()
      }
    });

    });
